import { useMemo } from "react";
import moment from "moment-timezone";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBriefcase, faCheckCircle, faLocationDot, faMoneyBill, faWarning } from "@fortawesome/free-solid-svg-icons";
import Avatar from "../../../components/Avatar";
import { useGroups } from "../../Settings/General/OrganisationLevelGroups/context";
import { renderUserName } from "../../../utils/helpers/user";
import { useCompanyTimeFormat } from "../../../utils/hooks/company";
import { useTranslation } from "react-i18next";
import { useOrgSettingsResourceLabel } from "../../../utils/hooks/useOrgSettingsResourceLabel";

function TimesheetRequestsView({ values, team }) {
    const { t } = useTranslation();
    const companyTimeFormat = useCompanyTimeFormat();

    const { groups } = useGroups();
    const renderOrgLevelResourceLabel = useOrgSettingsResourceLabel();

    return (
        <div className="rounded p-4 mb-5" style={{ border: "1px dashed #D5D5D1" }}>
            <div className="d-flex gap-6 w-100 align-items-center">
                {team && (
                    <div className="d-flex flex-column align-items-center gap-2">
                        <Avatar
                            user={values?.user}
                            size={60}
                            txtStyle={{ fontSize: "10px" }}
                        />

                        <span className="text-xs text-center">
                            {renderUserName(values?.user)}
                        </span>
                    </div>
                )}

                <div className="w-100">
                    <h3 className="text-dark">{moment(values?.data?.date).format("ddd, DD MMMM YYYY")}</h3>

                    {values?.type === "miss-punch" && (
                        <div className="d-flex align-items-center gap-2">
                            <h4 className="text-muted">
                                {moment.parseZone(values?.data?.startDate).format(companyTimeFormat)}
                            </h4>
                            <h4 className="text-muted">-</h4>
                            <h4 className={classNames(values?.status === "pending" ? "text-warning" : "text-success")}>
                                {moment.parseZone(values?.data?.endDate).format(companyTimeFormat)}
                                {values?.type === "miss-punch" && (
                                    <FontAwesomeIcon
                                        className={classNames(classNames(values?.status === "pending" ? "text-warning" : "text-success"), "ml-2")}
                                        icon={values?.status === "pending" ? faWarning : faCheckCircle}
                                        size="sm"
                                    />
                                )}
                            </h4>
                        </div>
                    )}

                    <div className="d-flex flex-column gap-1">
                        {/* <div>
                            <FontAwesomeIcon icon={faBriefcase} /> {renderSettingsResourceLabel(timesheet?.job)}
                        </div>
                        <div>
                            <FontAwesomeIcon icon={faLocationDot} /> {renderSettingsResourceLabel(timesheet?.location)}
                        </div>
                        <div>
                            <FontAwesomeIcon icon={faMoneyBill} /> {renderSettingsResourceLabel(timesheet?.payCode)}
                        </div> */}

                        {groups?.map((group) => {
                            const level = (group.level || "").replaceAll("_", "");

                            return values?.[level] ? (
                                <div className="d-flex align-items-center">
                                    <span className="font-weight-bold">{group.description}</span>:
                                    <span className="mx-2">{renderOrgLevelResourceLabel(values[level])}</span>
                                </div>
                            ) : null;
                        })}

                        {values?.data?.note && (
                            <div>
                                <span className="font-weight-bold">{t("note")}</span>
                                {": "}
                                {values?.data?.note}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TimesheetRequestsView;
